import accountableCardImg from 'assets/images/new_accountable_card.svg';
import BankIcon from 'assets/svg/icons/bankIcon';
import { Button } from 'components/atoms/Button';
import ModalHeading from 'components/molecules/ModalHeading';
import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import { motion } from 'motion/react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { fadeTransition } from 'utils/constants';

const MeetAccountableBanking: FC<{ onConfirm?: () => void }> = ({
  onConfirm,
}) => {
  const { t } = useTranslation();

  const user = useGetCurrentCustomerData().data;

  return (
    <motion.div
      {...fadeTransition}
      className="flex items-center justify-center flex-col relative pb-20"
      key="2"
    >
      <ModalHeading
        Icon={BankIcon}
        title={t('wallet.tutorial.slide_c.title')}
        subtitle={t('wallet.tutorial.slide_c.subtitle')}
        subtitleClassName="w-[80%]"
      />

      <div className="relative w-[72%] max-w-[300px] mt-3">
        <img
          src={accountableCardImg}
          alt="Accountable Aldo Card"
          className="w-full h-auto"
        />

        <p className="absolute bottom-14 left-10 text-primary font-semibold">{`${user?.firstName} ${user?.lastName}`}</p>
      </div>

      <Button
        color="bank"
        className="mt-6 w-[80%] absolute bottom-0"
        onClick={onConfirm}
      >
        {t('continue')}
      </Button>
    </motion.div>
  );
};

export default MeetAccountableBanking;
